import { HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { AuthService, LogoutService } from '@src/app/modules/auth';
import { reload } from '@src/utils';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  /**
   * TODO: Правильно использовать SessionService, но при его инжектировании Angular пишет ошибку,
   * что обнаружена циклическая зависимость.
   */
  private readonly authService = inject(AuthService);
  private readonly logoutService = inject(LogoutService);

  private isRefreshing = false;
  private readonly token$ = new BehaviorSubject<string | null>(null);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const token = this.authService.getToken();
    if (token) {
      request = this.getAuthRequest(request, token);
    }

    return next.handle(request).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.handle401Error(request, next);
        } else {
          console.log(error);
          return throwError(() => error);
        }
      }),
    );
  }

  private getAuthRequest(request: HttpRequest<any>, token: string | null) {
    const setHeaders = token ? { Authorization: `Bearer ${token}` } : undefined;
    const authRequest = request.clone({ setHeaders });
    return authRequest;
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    // TODO: найти решение получше
    if (request.url.includes('api/Token/refresh')) {
      return throwError(() => new Error('refreshToken истек'));
    }

    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.token$.next(null);

      const refreshToken = this.authService.getRefreshToken();
      if (!refreshToken) {
        return this.handleNotTokenError('refreshToken не заполнен');
      }

      return this.authService.changeTokenByRefreshToken(refreshToken).pipe(
        switchMap(tokens => {
          this.isRefreshing = false;
          const token = tokens.token;
          if (!token) {
            return this.handleNotTokenError('Поле token не заполнено');
          }

          this.token$.next(token);
          return next.handle(this.getAuthRequest(this.getCloneRequest(request), token));
        }),
        catchError(error => {
          return this.handleNotTokenError(error);
        }),
      );
    } else {
      return this.token$.pipe(
        filter(token => token !== null),
        take(1),
        switchMap(token => {
          return next.handle(this.getAuthRequest(this.getCloneRequest(request), token));
        }),
      );
    }
  }

  private getCloneRequest(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone();
  }

  private handleNotTokenError(error: any) {
    this.isRefreshing = false;
    this.logoutService.logout();
    reload();

    console.log(error);
    return throwError(() => new Error('Ошибка при обновлении токенов'));
  }
}
